import { Button, Text, View, useAuthenticator, useTheme } from '@aws-amplify/ui-react';

import React from 'react';

const year = new Date().getFullYear();

export const components = {
    Header() {
        const { tokens } = useTheme();

        return <View textAlign="center" padding={tokens.space.large}></View>;
    },

    Footer() {
        const { tokens } = useTheme();

        return (
            <View textAlign="center" padding={tokens.space.large}>
                <Text color={tokens.colors.neutral[80]} fontSize="0.75em">
                    Copyright &copy; 2018-{year} · Osano, Inc., a Public Benefit Corporation
                </Text>
            </View>
        );
    },

    SignIn: {
        Header() {
            const { tokens } = useTheme();
            return (
                <Text
                    color={tokens.colors.font.tertiary}
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                >
                    Please log in to take this assessment
                </Text>
            );
        },
        Footer() {
            const { tokens } = useTheme();
            const { toResetPassword } = useAuthenticator();
            return (
                <View textAlign="center" padding={tokens.space.small}>
                    <Button
                        color={tokens.colors.font.secondary}
                        fontWeight="normal"
                        onClick={toResetPassword}
                        size="small"
                        variation="link"
                    >
                        Reset Password
                    </Button>
                </View>
            );
        },
    },
};

export default components;
